export const MAX_NUMBER_OF_ALARMS = 25;
